

<app-page-panel
  [showBackButton]="true"
  iconNameFontAwesome="lock"
  pageTitle="Berechtigungen | Autorisierung"
  [showDetailsButton]="false"
  [showSidepanelButton]="false"
  [showBackColor]="true"
  (backButtonClicked)="backButtonClicked()">
    <div class="flex flex-fill flex-gap-8 flex-col flex-stretch-self">
        <br>   
        <p class="font-title-contrast">Sie haben keine oder nicht ausreichende Berechtigungen.</p>
        <p class="font-subtitle-contrast">Für den Zugriff auf Inhalte des HCH-BAT (Budgetantragstool) benötigen Sie entsprechende Berechtigungen.<br>
        Bitte wenden Sie sich für die Einrichtung der Berechtigungen an die Administration der Anwendungen PK-DB und HCH-BAT der HafenCity GmbH.<br>
        </p>
        <br>   
        <p class="font-title-contrast">Kontakt und AnsprechpartnerInnen</p>
        <p class="font-subtitle-contrast">
            Jeannine Thiel<br>
            <a href="mailto:thiel@hafencity.com">thiel&#64;hafencity.com</a><br>
            Finanzen und Controlling<br>
            HafenCity Hamburg GmbH<br>
            Osakaallee 11, D 20457 Hamburg<br>
            Tel: +49 40 374726 - 66<br>
            Fax: +49 40 374726 - 26<br>
            <a href="https://www.hafencity.com/kontakt" target="_blank">www.hafencity.com/kontakt</a><br>
        </p>
        <br>   
        <p class="font-subtitle-contrast">
        Mit freundlichen Grüßen<br>
        Ihre HafenCity GmbH
        </p>
    </div>
</app-page-panel>